import React from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

const ErrorView = ({ errors, setError, firstView }) => {
  const navigate = useNavigate();

  const backToStart = () => {
    setError(false);
    navigate(firstView);
  };

  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <section className="db-section">
        <p className="db-question">Something went wrong</p>
        <p>
          Sorry, we were unable to complete your enquiry at this time
          {errors.length > 0
            ? ' due to the following reasons.'
            : '. Please try again.'}
        </p>
        {errors.length > 0 && (
          <ul className="ch-list ch-measure ch-color--ac-red">
            {errors.map((error, key) => (
              <li key={key}>{error}</li>
            ))}
          </ul>
        )}
      </section>
      <section className="db-section db-section--cta">
        <button
          className="ch-btn ch-btn--block ch-btn--cta"
          onClick={backToStart}
          type="button"
        >
          Try again
        </button>
      </section>
    </div>
  );
};

export default ErrorView;

ErrorView.propTypes = {
  errors: PropTypes.array,
  firstView: PropTypes.string,
  setError: PropTypes.func,
};
